// @ts-ignore
// eslint-disable-next-line import/named
import ApiHandler, { RequestApi } from 'requests/apiHandler'
import NotImplementedError from 'requests/errors/notImplementedError'
// @ts-ignore
import { AxiosResponse } from 'axios'
import ExportDto, { ErrorExportDto } from 'requests/objects/exportDto'
import Export from 'requests/objects/export'
import TExportType from 'types/exportType'

/**
 * ExportHandler
 * @augments {ApiHandler<object, object>}
 */
export default class ExportHandler extends ApiHandler {
    constructor() {
        super({ type: ExportDto, errorType: ErrorExportDto, key: 'export' })
    }

    /**
     * Get all
     * @returns {RequestApi<Export[]>} Request
     */
    getAll() {
        const request = this.initFetchRequest({})

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => res.data.exports?.map(x => new (Export)(x)) ?? [])
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * @param {import('axios').AxiosRequestConfig['params']=} params Params
     * @returns {RequestApi<object[]>} Request
     */
    getCollaborators(params) {
        const request = this.initFetchRequest({ url: ['collaborators'], params })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => (/** @type {AxiosResponse<any>} */(res).data.collaborators))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @param {number} id id
     * @returns {RequestApi<Export>} Request
     */
    getById(id) {
        const request = this.initFetchRequest({ url: [id] })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => new Export(res.data?.exports))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    updateById() {
        throw new NotImplementedError()
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    removeById() {
        throw new NotImplementedError()
    }

    /**
     * Cancel export
     * @param {number} exportId exportId
     * @param {TExportType} type type
     * @returns {RequestApi<Export>} Request
     */
    cancelExport(exportId, type) {
        const request = this.initFetchRequest({
            url: [exportId, 'cancel', type],
            method: 'POST',
        })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => new Export(res.data?.exports))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * Relaunch export
     * @param {number} exportId exportId
     * @param {TExportType} type type
     * @returns {RequestApi<Export>} Request
     */
    relaunchExport(exportId, type) {
        const request = this.initFetchRequest({
            url: [exportId, 'relaunch', type],
            method: 'POST',
        })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => new Export(res.data?.exports))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * get agent status
     * @returns {RequestApi<boolean>} agent is active
     */
    getAgentStatus() {
        const request = this.initFetchRequest({
            url: ['agent-status'],
            method: 'GET',
        })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => res.data?.isActive)
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * Get all
     * @param {import('axios').AxiosRequestConfig['params']=} params Params
     * @param {number} page page
     * @param {number} [recordsPerPage] recordsPerPage
     * @returns {import('requests/apiHandler').RequestPageApi<Export>} Request
     */
    getAllFromPage(params = {}, page = 1, recordsPerPage = 25) {
        const request = this.initFetchRequest({ params: { ...params, page, recordsPerPage } })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => res.data).then(({
                    exports, totalRecords, totalPages,
                }) => ({
                    items: exports?.map(x => new Export(x)) ?? [],
                    totalRecords,
                    totalPages,
                }))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }
}
